<template>
  <v-app :class="{ 'background-app': !$route.meta.whiteBackground }">
    <app-bar v-if="$store.state.auth.user.authenticated" />
    <div class="d-flex flex-column">
      <navigation-drawer />
      <v-row align="start" justify="center" no-gutters>
        <v-col cols="12" :style="($route.meta.requireAuth && $route.meta.displayNavigationDrawer) ? 'padding-left: 100px !important; padding-right: 35px !important' : ''">
          <v-main :class="{ 'pl-0': !$route.meta.displayDrawer && $route.meta.displayNavigationDrawer }">
            <v-container :class="{ 'pa-0': !$route.meta.requireAuth }" fluid>
              <router-view :key="$route.fullPath"></router-view>
            </v-container>
          </v-main>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>
<script>
import AppBar from '@/components/menu/AppBar'
import NavigationDrawer from '@/components/menu/NavigationDrawer'

export default {
  components: {
    AppBar,
    NavigationDrawer
  },
  watch: {
    $route (to, from) {
      if (to.path !== from.path) {
        this.$vuetify.goTo(1, { duration: '0', easing: 'linear' })
      }
    }
  }
}
</script>